import React, { PureComponent } from "react";
import VisualitzacioMapaLlegendaItem from "./VisualitzacioMapaLlegendaItem";
import styles from "./VisualitzacioMapaLlegenda.module.css";
import { colorsIcones } from "../../constantsObservacions";

const optionsLlegenda = [
  { color: colorsIcones["1"], descripcio: "Observat" },
  { color: colorsIcones["2"], descripcio: "No Observat" },
  { color: colorsIcones["3"], descripcio: "Dubte" }
];

function renderItemsLlegenda(optionsLlegenda) {
  return <VisualitzacioMapaLlegendaItem optionsLlegenda={optionsLlegenda} />;
}

class VisualitzacioMapaLlegenda extends PureComponent {
  render() {
    return (
      <div className={styles.MapaLlegenda}>
        {renderItemsLlegenda(optionsLlegenda)}
      </div>
    );
  }
}

export default VisualitzacioMapaLlegenda;
